import { EMAIL, SD_PHONE_NUMBER } from "@/lib/consts";
import type { Org, Site } from "@/content/types";

const NAME = "Orsak Langner & Barthel PLLC";
const URL = process.env.NEXT_PUBLIC_DOMAIN ?? "";

// NOTE: breadcrumb needs path name
export const STRUCTURED_DATA_IDS = {
  website: `${URL}/#website`,
  org: `${URL}/#org`,
  biz: `${URL}/#localbusiness`,
  breadcrumb: (pathname?: string) => {
    if (!pathname) {
      return `${URL}/#breadcrumb`;
    }

    return `${URL}${pathname}/#breadcrumb`;
  },
  webpage: (pathname: string) => `${URL}${pathname}/#webpage`,
  service: (pathname: string) => `${URL}${pathname}/#service`,
  itemList: (pathname: string) => `${URL}${pathname}/#itemlist`,
};

export const ORG: Org = {
  name: NAME,
  alternateName: "Orsak CPAs",
  legalName: NAME,
  description:
    "Orsak Langner & Barthel PLLC is a trusted CPA firm in Houston, Texas, serving businesses and individuals statewide. We deliver expert accounting, tax, and advisory services.",
  url: URL,
  logo: "orsak-cpas-small-logo",
  telephone: SD_PHONE_NUMBER,
  email: EMAIL,
  address: {
    streetAddress: "515 Post Oak Blvd, Suite 700",
    addressLocality: "Houston",
    addressRegion: "TX",
    postalCode: "77027",
    addressCountry: "US",
    geo: { latitude: 29.7542503482119, longitude: -95.45255081729648 },
  },
};

export const SITE: Site = {
  name: NAME,
  url: URL,
  applicationName: NAME,
  creator: NAME,
  publisher: NAME,
  authors: [{ name: NAME, url: URL }],
  generator: "Next.js",
  referrer: "origin-when-cross-origin",
};
